import Link from "next/link";
import Media_Card from "../ui/media-card/media-card";
import { MEDIA_BASE_URL } from "@/utils/api";

const Related_Blogs = ({ blog_data }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;
  const relatedBlogs =
    blog_data?.length >= 5 ? blog_data.slice(0, 5) : blog_data;

  return (
    <div className="related_blogs mb-5 lg:mb-[2.5vw]">
      <h2 className="font-secondary text-black uppercase text-[22px] lg:text-[1.8vw] mb-4 lg:mb-[1.5vw]">
        Related Blog
      </h2>
      <div className="flex flex-wrap gap-5 lg:gap-[2vw]">
        {relatedBlogs?.map((item, i) => (
          <div className="w-full md:w-[300px] lg:w-[25vw]" key={i}>
            <Media_Card
              imgSrc={`${mediaBaseUrl}${item.banner}`}
              title={item.title}
              slug={item.slug}
              link={{
                pathname: `/blog/${item.slug}`,
                // query: {
                //   slug: item.slug,
                // },
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Related_Blogs;
